import { Col } from 'react-bootstrap';
import React, { useState } from 'react';
import { TriangleBlueIcon } from './icons/TriangleBlueIcon.jsx';
import CustomFieldEditor from './CustomFieldEditor.jsx';

const OverviewTextField = ({ isFieldWithEditor, entity, field, index }) => {
  const [showedBlock, setShowedBlock] = useState(false);

  const renderFieldContent = (field) => {
    if (isFieldWithEditor && entity[field.key]) {
      return (
        <CustomFieldEditor
          field={{ data: entity[field.key], key: field.key }}
        />
      );
    }

    return (
      <span style={{ padding: '.4em 0' }}>{entity[field.key] || '—'}</span>
    );
  };

  return (
    <Col xs={6} className="m-b-24">
      <div className="text-muted m-b-12">
        <h3 style={{ fontSize: '20px' }}>{field.name}</h3>
      </div>
      <div
        style={{
          position: 'relative',
          height: `${showedBlock ? 'auto' : '82px'}`,
          overflowY: 'hidden',
        }}
      >
        {renderFieldContent(field)}
        {!showedBlock && entity[field.key] ? (
          <span
            style={{
              position: 'absolute',
              zIndex: 9,
              bottom: 0,
              left: 0,
              width: '100%',
              height: '16px',
              background:
                'linear-gradient(0deg, rgba(255, 255, 255, 1) 33%, rgba(255, 255, 255, 0) 100%)',
            }}
          ></span>
        ) : null}
      </div>
      {entity[field.key] ? (
        <button
          type="button"
          className="btn-clear bg-transparent btn-link flex m-t-8"
          onClick={() => setShowedBlock(!showedBlock)}
          style={{ paddingLeft: 0 }}
        >
          <span className="m-r-8">
            {!showedBlock ? 'Show More' : 'Show Less'}
          </span>
          <TriangleBlueIcon
            style={{ height: '20px' }}
            transform={`rotate(${!showedBlock ? '180' : '0'})`}
          />
        </button>
      ) : null}
    </Col>
  );
};

export default OverviewTextField;
